import { useEffect, useState, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/shared/auth/authStore";

export function RequireAuth({ children, roles }: { children: ReactNode; roles?: string[] }) {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const initAuth = useAuthStore((s) => s.initAuth);
  const includeAnyRole = useAuthStore((s) => s.includeAnyRole);

  useEffect(() => {
    initAuth().finally(() => setReady(true));
  }, [initAuth]);

  if (!ready) {
    return (
      <div role="status" aria-live="polite" className="flex min-h-screen items-center justify-center bg-canvas text-body text-fg-subtle">
        Carregando sessão…
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles?.length && !includeAnyRole(roles)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
